'use strict';

var intentionColors = {};

exports.__exports = intentionColors;
//# sourceMappingURL=intentionColors.cjs.map
